<script>
  import {
    branchesMethods,
  } from '@state/helpers'

  export default {
    props: {
      defaultFilters: {
        type: Array,
        default: () => [],
      },
      preloadData: {
        type: Array,
        default: () => [],
      },
      usePreload: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        branches: [],
        boundCollapse: true,
      }
    },
    computed:{
      branchFilter(){
        return this.branches.map(el => {
          if (el.selected){
            return el.id
          }
        }).filter(el => el)
      }
    },
    watch: {
      branchFilter (val) {
        this.$emit('filter', {
          branch_ids: val,
        })
      },
    },
    async created() {
      // apply defaults
      if (this.defaultFilters && this.defaultFilters.length > 0){
        this.branchesFilter = [...this.defaultFilters]
      }

      // load options
      await this.loadData()
    },
    methods: {
      ...branchesMethods,
      async loadData () {
        if (this.usePreload){
          this.branches = this.preloadData
        }else{
          const { data } = await this.getListBranches({
            fields: 'id, name',
            limit: 500,
            orderBy: 'name',
            sortedBy: 'asc',
          })
          const branches = data.data
          branches.forEach(el => el.selected = true)
          this.branches = branches
        }
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-branch
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by branch</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
      <FabricBadge
        :styling-bg="branchFilter.length ? 'badge-primary' : 'badge-light'"
        :copy="branchFilter.length"
      />
    </div>
    <FabricCollapse
      id="accordion-branch"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="boundCollapse">
      <div
        class="block-content"
        :class="{ 'ovf-y-scroll tw-overflow-x-hidden scroll-primary mg-r-5 pd-t-u mg-t-10 mx-h-300': (branches && branches.length > 8) }">
        <FabricCheckbox
          v-for="branch in branches"
          :key="branch.id"
          v-model="branch.selected"
          slot-classes="tw-pl-3 tw-text-black"
        >{{ branch.name }}</FabricCheckbox>
      </div>
    </FabricCollapse>
  </div>
</template>
